var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,2.4492935982947064e-16,-2.449293598294706e-16,1,-1.9539925233402755e-14,-1.4210854715202004e-14)"
  }, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "low_charge",
    "data-name": "low charge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.6373 31.3707a2.0858 2.0858 0 0 1 -1.504.6293h-12.8a2.14 2.14 0 0 1 -2.1333-2.1333v-23.4667a2.14 2.14 0 0 1 2.1333-2.1333h12.8a2.14 2.14 0 0 1 2.1334 2.1333v23.7286z",
    fill: "#4d4d4d",
    "data-original": "#4d4d4d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.2667 26.6667v3.4666l-.6293 1.2373a2.0855 2.0855 0 0 1 -1.5041.6294h-12.8a2.14 2.14 0 0 1 -2.1333-2.1333v-3.2z",
    fill: "#e71212",
    "data-original": "#a6e063",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.2 21.333h17.067v5.333h-17.067z",
    fill: "#e32310",
    "data-original": "#8ad64d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4667 0h4.5333a2 2 0 0 1 2 2v2.2667a0 0 0 0 1 0 0h-8.5333a0 0 0 0 1 0 0v-2.2667a2 2 0 0 1 2-2z",
    fill: "#333333",
    "data-original": "#333333",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.4,
    cy: 25.6,
    fill: "#a53e33",
    r: 6.4,
    "data-original": "#ff5543",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.4 26.0417a1.0667 1.0667 0 0 1 -1.0667-1.0667v-1.7714a1.0667 1.0667 0 0 1 2.1334 0v1.7714a1.0667 1.0667 0 0 1 -1.0667 1.0667z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.4 29.063a1.0667 1.0667 0 0 1 -1.0667-1.0666v-.2631a1.0667 1.0667 0 0 1 2.1334 0v.2631a1.0667 1.0667 0 0 1 -1.0667 1.0666z",
    fill: "#f2f2f2",
    "data-original": "#f2f2f2",
    className: ""
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStock);
export default __webpack_public_path__ + "static/media/empty-stock.879348c22e891cb1d5e989c9c285ddb3.svg";
export { ForwardRef as ReactComponent };